export const SAVINGS_STAMP_LOTTIE_ID = "Saving_stamp_2_char%20support%20added.json";
export const SAVINGS_STAMP_STORAGE_KEY = "savings_stamp_frequency_threshold";
export const IS_SAVINGS_STAMP_SHOWN = "is_savings_stamp_shown";
export const SAVINGS_STAMP_SID_LIMIT = 2;
